<template>
  <div>
    <div data-cy="form-label" class="b-dialog__top-panel mb-4">
      <h2>{{$t('CONTENT.contract.contract_editing')}}</h2>
      <button class="b-btn b-btn_border_none" @click="closePaymentEditPopup">
        <dynamic-icon icon="close" />
      </button>
    </div>
    <form class="b-form b-dialog__form">
      <server-error :error="error" />
      <PaymentWidgetWithoutStore
        :payment="formData"
        :assetComponent="assetComponent"
        :unitOfMeasure="unitOfMeasure"
        :validationErrors="validationErrors"/>
      <div class="row mt-4">
        <div class="col-6 offset-6">
          <div class="b-form__container b-form__container_type_flex b-form__container_type_flex_end">
            <button
              data-cy="save-button"
              class="b-btn b-btn_type_primary"
              type="submit"
              :disabled="isDisabledSavePayment"
              @click="onSubmit">
                {{$t('CONTENT.save')}}
            </button>
            <button class="b-btn b-btn_type_empty m-2" @click.prevent="closePaymentEditPopup">
              {{$t('CONTENT.cancel')}}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  export default {
    props: {
      payment: {
        type: Object
      },
      unitOfMeasure: {
        type: String
      },
      assetComponent: {
        type: Object
      }
    },
    data() {
      return {
        error: null,
        formData: {},
        validationErrors: []
      };
    },
    created() {
      this.updateFormData();
    },
    computed: {
      isDisabledSavePayment() {
        return this.formData.indexation.indexationKindId === null;
      }
    },
    methods: {
      updateFormData() {
        this.formData = _.cloneDeep (this.payment);
      },
      closePaymentEditPopup() {
        this.$emit("close");
        this.formData = _.cloneDeep(this.payment);
      },
      async onSubmit(e) {
        e.preventDefault();
        if (!this.validate()) return;
        this.$eventBus.$emit('savePaymentEditing', this.formData);
        this.$emit("close");
        this.formData = _.cloneDeep(this.payment);
      },
      validate() {
        this.validationErrors = [];
        let payment = _.cloneDeep (this.formData);
        if (!payment.paymentNameId) {
          this.validationErrors.push("paymentNameId");
        }
        if (!payment.currencyCode) {
          this.validationErrors.push("currencyCode");
        }
        if (!payment.leaseFrequency) {
          this.validationErrors.push("leaseFrequency");
        }
        if (!payment.startDate) {
          this.validationErrors.push("startDate");
        }
        if (!payment.endDate) {
          this.validationErrors.push("endDate");
        }
        if (!payment.firstPaymentDate) {
          this.validationErrors.push("firstPaymentDate");
        }
        if (!payment.paymentFrequency) {
          this.validationErrors.push("paymentFrequency");
        }
        if (!payment.indexation || !payment.indexation.indexationKindId) {
          this.validationErrors.push("indexationKindId");
        }
        if (!payment.discount || (!payment.discount.isAuto && (payment.discount.discountRate === null || payment.discount.discountRate === undefined))) {
          this.validationErrors.push("discountPercent");
        }
        if (payment.leaseRate === null || payment.leaseRate === undefined) {
          this.validationErrors.push("leaseRate");
        }
        if (!payment.currencyRateParameters.type) {
          this.validationErrors.push("currencyCodeType");
        }
        return this.validationErrors.length <= 0;
      }
    }
  };
</script>
